import { Action } from '@ngrx/store';

import { ListDetailsFormModel } from '®shared/reading-list/models';

export enum ListDetailsEditorActionTypes {
  LIST_DETAILS_EDITOR_SHOW_MODAL = '[List details editor] Show modal',
  LIST_DETAILS_EDITOR_HIDE_MODAL = '[List details editor] Hide modal',
  LIST_DETAILS_EDITOR_SAVE = '[List details editor] Save list details',
  LIST_DETAILS_EDITOR_SAVE_SUCCEEDED = '[List details editor] Save list details succeeded',
  LIST_DETAILS_EDITOR_SAVE_FAILED = '[List details editor] Save list details failed',
}

export interface ListIdPayload {
  listId: string;
}

export class ListDetailsEditorShowModalAction implements Action {
  readonly type = ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SHOW_MODAL;

  constructor(public payload: ListIdPayload) {}
}

export class ListDetailsEditorHideModalAction implements Action {
  readonly type = ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_HIDE_MODAL;
}

interface ListDetailsPayload extends ListIdPayload {
  listDetails: ListDetailsFormModel;
}

export class ListDetailsEditorSaveAction implements Action {
  readonly type = ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SAVE;

  constructor(public payload: ListDetailsPayload) {}
}

export class ListDetailsEditorSaveSucceededAction implements Action {
  readonly type =
    ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SAVE_SUCCEEDED;

  constructor(public payload: ListDetailsPayload) {}
}

export interface ListDetailsSaveFailedPayload extends ListDetailsPayload {
  error: any;
}

export class ListDetailsEditorSaveFailedAction implements Action {
  readonly type = ListDetailsEditorActionTypes.LIST_DETAILS_EDITOR_SAVE_FAILED;

  constructor(public payload: ListDetailsSaveFailedPayload) {}
}

export type ListDetailsEditorActions =
  | ListDetailsEditorShowModalAction
  | ListDetailsEditorHideModalAction
  | ListDetailsEditorSaveAction
  | ListDetailsEditorSaveSucceededAction
  | ListDetailsEditorSaveFailedAction;
